module.exports = __webpack_public_path__ + "static/media/search-vk.f12b1293.svg";